import axiosInstance from "./axiosInstance";

export interface EmployeeGradeApi {
  publicId: string;
  gradeName: string;
  gradeLevel: number;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export interface EmployeeGradeFilters {
  gradeName?: string;
  gradeLevel?: number;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
}

export interface EmployeeGradeSearchPage {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: EmployeeGradeApi[];
  errors: unknown[];
}

export interface EmployeeGradeSearchResponse {
  success: boolean;
  message: string;
  data: EmployeeGradeSearchPage;
  errors: unknown[];
}

export interface CreateEmployeeGradePayload {
  gradeName: string;
  gradeLevel: number;
  description: string;
  isActive: boolean;
}

export interface CreateEmployeeGradeResponse {
  success: boolean;
  message: string;
  data: string;
  errors: unknown[];
}

export interface UpdateEmployeeGradeResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export interface DeleteEmployeeGradeResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getEmployeeGrades = async (
  filters: EmployeeGradeFilters = {},
): Promise<EmployeeGradeSearchResponse> => {
  try {
    const response = await axiosInstance.get<EmployeeGradeSearchResponse>(
      "/hr/settings/grades/search",
      {
        params: {
          GradeName: filters.gradeName || undefined,
          GradeLevel: filters.gradeLevel ?? undefined,
          IsActive: filters.isActive ?? undefined,
          PageNumber: filters.pageNo ?? 1,
          PageSize: filters.pageSize ?? 20,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createEmployeeGrade = async (
  payload: CreateEmployeeGradePayload,
): Promise<CreateEmployeeGradeResponse> => {
  try {
    const response = await axiosInstance.post<CreateEmployeeGradeResponse>(
      "/hr/settings/grades",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEmployeeGrade = async (
  publicId: string,
  payload: CreateEmployeeGradePayload,
): Promise<UpdateEmployeeGradeResponse> => {
  try {
    const response = await axiosInstance.put<UpdateEmployeeGradeResponse>(
      `/hr/settings/grades/${publicId}`,
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployeeGrade = async (
  publicId: string,
): Promise<DeleteEmployeeGradeResponse> => {
  try {
    const response =
      await axiosInstance.delete<DeleteEmployeeGradeResponse>(
        `/hr/settings/grades/${publicId}`,
        {
          headers: {
            ...getAuthHeader(),
          },
        },
      );

    return response.data;
  } catch (error) {
    throw error;
  }
};